"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._PINDailyPeriod = void 0;
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importStar(require("react"));
var react_2 = require("@iconify/react");
var _TimeStringUtils_1 = require("./_TimeStringUtils");
var _DayPeriod_1 = require("./_DayPeriod");
function _PINDailyPeriod(_a) {
    var _b, _c, _d, _e;
    var periods = _a.periods, dayStartTime = _a.dayStartTime, dayEndTime = _a.dayEndTime, onChange = _a.onChange, index = _a.index, wrapperHeight = _a.wrapperHeight, onDragStateChange = _a.onDragStateChange, minPeriodDurationUsed = _a.minPeriodDurationUsed, periodDurationIncrement = _a.periodDurationIncrement;
    var period = periods[index];
    var _f = react_1.useState(0), startY = _f[0], setStartY = _f[1];
    var _g = react_1.useState(0), dragTopModifier = _g[0], setDragTopModifier = _g[1];
    var _h = react_1.useState(0), dragModifier = _h[0], setDragModifier = _h[1];
    var _j = react_1.useState(0), dragBottomModifier = _j[0], setDragBottomModifier = _j[1];
    var dayStartMinute = _TimeStringUtils_1.timeStringToMinutes(dayStartTime);
    var dayEndMinute = _TimeStringUtils_1.timeStringToMinutes(dayEndTime);
    var minStartMinute = _TimeStringUtils_1.timeStringToMinutes((_c = (_b = periods[index - 1]) === null || _b === void 0 ? void 0 : _b.endAt) !== null && _c !== void 0 ? _c : dayStartTime);
    var maxEndMinute = _TimeStringUtils_1.timeStringToMinutes((_e = (_d = periods[index + 1]) === null || _d === void 0 ? void 0 : _d.startAt) !== null && _e !== void 0 ? _e : dayEndTime);
    var pxPerMinute = wrapperHeight / (dayEndMinute - dayStartMinute);
    var startMinute = _TimeStringUtils_1.timeStringToMinutes(period.startAt);
    var endMinute = _TimeStringUtils_1.timeStringToMinutes(period.endAt);
    var stepSize = periodDurationIncrement * pxPerMinute;
    var top = (startMinute - dayStartMinute) * pxPerMinute;
    var height = (endMinute - startMinute) * pxPerMinute;
    var minTopOffset = (minStartMinute - startMinute) * pxPerMinute;
    var maxTopOffset = (endMinute - startMinute - minPeriodDurationUsed) * pxPerMinute;
    var maxBottomOffset = (maxEndMinute - endMinute) * pxPerMinute;
    var minBottomOffset = -(endMinute - startMinute - minPeriodDurationUsed) * pxPerMinute;
    var displayedStartAt = _TimeStringUtils_1.minutesToTimeString(((dragTopModifier + dragModifier) / pxPerMinute) + startMinute);
    var displayedEndAt = _TimeStringUtils_1.minutesToTimeString(((dragBottomModifier + dragModifier) / pxPerMinute) + endMinute);
    var periodHeight = height - dragTopModifier + dragBottomModifier;
    function onDelete() {
        onChange(index, null);
    }
    function onDragStart(e) {
        setStartY(e.clientY);
        onDragStateChange(true);
        /* Create a transparent img to hide drag image */
        var img = document.createElement("img");
        img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
        e.dataTransfer.setDragImage(img, 0, 0);
    }
    function onDragFactory(minOffset, maxOffset, setModifier) {
        return function (e) {
            var pxOffset = Math.round((e.clientY - startY) / stepSize) * stepSize;
            setModifier(function (oldModifier) {
                var newModifier = Math.min(Math.max(minOffset, pxOffset), maxOffset);
                /**
                 * Chrome fire a last event with a wrong clientY that we want to ignore.
                 * If clientY is negative or offset is very different from the previous one,
                 * ignore the change. Fast drag can trigger false positive, but there is no
                 * visible impact on UX.
                 */
                return e.clientY < 0 || Math.abs(pxOffset - oldModifier) > 100
                    ? oldModifier
                    : newModifier;
            });
        };
    }
    return (react_1.default.createElement("div", { className: "period", style: {
            top: top + dragTopModifier + dragModifier + "px",
            height: periodHeight + "px"
        } },
        react_1.default.createElement("div", { className: "top-handle", draggable: true, onDragStart: onDragStart, onDrag: onDragFactory(minTopOffset, maxTopOffset, setDragTopModifier), onDragEnd: function () {
                onChange(index, {
                    startAt: _TimeStringUtils_1.minutesToTimeString(startMinute + (dragTopModifier / pxPerMinute)),
                    endAt: period.endAt,
                });
                setDragTopModifier(0);
                onDragStateChange(false);
            } },
            react_1.default.createElement(react_2.Icon, { icon: "mdi:drag-horizontal-variant" })),
        react_1.default.createElement("button", { className: "close-button", onClick: onDelete },
            react_1.default.createElement(react_2.Icon, { icon: "mdi:close" })),
        react_1.default.createElement("div", { className: "period-label", style: { fontSize: Math.min(periodHeight - 20, 12) / 10 + "rem" }, draggable: true, onDragStart: onDragStart, onDrag: onDragFactory(minTopOffset, maxBottomOffset, setDragModifier), onDragEnd: function () {
                onChange(index, {
                    startAt: _TimeStringUtils_1.minutesToTimeString(startMinute + (dragModifier / pxPerMinute)),
                    endAt: _TimeStringUtils_1.minutesToTimeString(endMinute + (dragModifier / pxPerMinute)),
                });
                setDragModifier(0);
                onDragStateChange(false);
            } }, displayedStartAt + " - " + displayedEndAt),
        react_1.default.createElement("div", { className: "bottom-handle", draggable: true, onDragStart: onDragStart, onDrag: onDragFactory(minBottomOffset, maxBottomOffset, setDragBottomModifier), onDragEnd: function () {
                onChange(index, {
                    startAt: period.startAt,
                    endAt: _TimeStringUtils_1.minutesToTimeString(endMinute + (dragBottomModifier / pxPerMinute)),
                });
                setDragBottomModifier(0);
                onDragStateChange(false);
            } },
            react_1.default.createElement(react_2.Icon, { icon: "mdi:drag-horizontal-variant" }))));
}
exports._PINDailyPeriod = _PINDailyPeriod;
_PINDailyPeriod.propTypes = {
    periods: prop_types_1.default.arrayOf(_DayPeriod_1.DayPeriodPropType.isRequired).isRequired,
    dayStartTime: prop_types_1.default.string.isRequired,
    dayEndTime: prop_types_1.default.string.isRequired,
    onChange: prop_types_1.default.func.isRequired,
    index: prop_types_1.default.number.isRequired,
    wrapperHeight: prop_types_1.default.number.isRequired,
    minPeriodDurationUsed: prop_types_1.default.number.isRequired,
    onDragStateChange: prop_types_1.default.func.isRequired,
    periodDurationIncrement: prop_types_1.default.number.isRequired,
};
//# sourceMappingURL=_PINDailyPeriod.js.map